
<template>
  <button v-on:click="onToggle">
    ssss
  </button>
      <Modal
        title="Download Setup"
        btnTextSubmit="Submit"
        btnText="Add Group"
        :btnShow="false"
        :isOpenEx="isOpen"
        @submit=""
      >
        <template v-slot:body>
          <div class="space-y-5 pb-5">
            <div class="space-y-3">
              <div class="flex gap-2 justify-between">
                <div class="flex-1 w-50">
                  <p>Start Date</p>
                  <input
                    type="date"
                    placeholder=""
                    class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                    v-model="name"
                  />
                </div>
                <div class="flex-1 w-50" >
                  <p>End Date</p>
                  <input
                    type="date"
                    placeholder=""
                    class="p-2 dark:[color-scheme:dark] border dark:border-gray-600 dark:bg-gray-700 w-full rounded outline-none"
                    v-model="name"
                  />
                </div>
              </div>
              <div>
                <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">Option</h3>
                <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                    <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                        <div class="flex items-center ps-3">
                            <input id="horizontal-list-radio-license" type="radio" value="" name="list-radio" class="ml-10 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                            <label for="horizontal-list-radio-license" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Selected</label>
                        </div>
                    </li>
                    <li class="w-full dark:border-gray-600">
                        <div class="flex items-center ps-3">
                            <input id="horizontal-list-radio-passport" type="radio" value="" name="list-radio" class="ml-10 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                            <label for="horizontal-list-radio-passport" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">All</label>
                        </div>
                    </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
      </Modal>
</template>
<script>
import { useCounterStore } from "@/store/counter";
import { mapActions, mapState } from "pinia";
import people from '@/mockDataPeople.json';
import TableTanstack from "./TableTanstack.vue";
import Modal from "@/components/modal.vue";

export default {
  data() {
    return {
      people,  // assuming this is a static dataset, otherwise load dynamically
      dataCheck : true,
      isOpen: false
    };
  },
  components: {
    TableTanstack,Modal
  },
  methods: {
    ...mapActions(useCounterStore,['getAllPlanst']),
    onToggle() {
      this.isOpen = !this.isOpen;
    }
  },
  computed: {
    ...mapState(useCounterStore, ['dataAllPlants']),
    isModalVisible() {
      return this.isOpen;
    }
  },
  created(){
    this.getAllPlanst()
  }
};
</script>
